import { render, staticRenderFns } from "./SandBox.vue?vue&type=template&id=8eabad7a&scoped=true"
import script from "./SandBox.vue?vue&type=script&lang=js"
export * from "./SandBox.vue?vue&type=script&lang=js"
import style0 from "./SandBox.vue?vue&type=style&index=0&id=8eabad7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eabad7a",
  null
  
)

export default component.exports